import * as Sentry from '@sentry/capacitor'
import { debugIntegration } from '@sentry/react'
import keys from 'lodash/keys'

import { config } from '@/config'

import packageJson from '../../../package.json'

export function init() {
  const sentryOptions: Sentry.CapacitorOptions = {
    dsn: 'https://2b2c9947a30b4df79e3346d26f1050c3@o268566.ingest.sentry.io/5946968',
    release: 'utoniq-mono@' + packageJson.version,
    maxBreadcrumbs: 50,
    attachStacktrace: true,
    environment: config.environment,
    dist: process.env.CI_BUILD_NUMBER ?? undefined,
    integrations: [Sentry.browserTracingIntegration()],
    tracePropagationTargets: [
      'localhost',
      /^capacitor:\/\//,
      'capacitor://localhost',
      'http://localhost:*',
      'https://localhost:*',
      'ionic://localhost',
      config.domain,
    ],
  }

  // When we're developing locally
  if (process.env.NODE_ENV !== 'production') {
    // Instead, dump the errors to the console
    //@ts-ignore
    sentryOptions.integrations = [debugIntegration({ debugger: false })]
  }
  /**
   * @Note missing tags if init sentry after add tags
   */
  Sentry.init(sentryOptions)

  Sentry.setTag('application', packageJson.name)
  Sentry.setTag('applicationKey', config.applicationKey)
}

type Tags = {
  userId?: string
  appVersion: string | null
  liveupdate: string | null
}
export function setTags(tags: Tags): void {
  const tagKeys = keys(tags) as [keyof Tags]
  tagKeys.forEach(key => {
    if (tags?.[key]) {
      Sentry.setTag(key, tags[key])
    }
  })
}
